import { TranslationKeys } from './en';

export const et: TranslationKeys = {
  // Common
  common: {
    loading: 'Laadimine...',
    error: 'Viga',
    cancel: 'Tühista',
    save: 'Salvesta',
    continue: 'Jätka',
    back: 'Tagasi',
    close: 'Sulge',
    select: 'Vali',
    required: 'Kohustuslik',
    appTitle: 'Fire and Ice',
    goBack: 'Mine tagasi',
    goHome: 'Avalehele',
    success: 'Õnnestus',
    inTallinn: 'Tallinnas',
  },

  // Page Titles
  pageTitles: {
    home: 'Uue ajastu wellness-stuudio',
    book: 'Broneeri aeg',
    pricing: 'Hinnakiri',
    promotions: 'Kampaaniad',
    contact: 'Kontakt',
    checkBalance: 'Kontrolli kinkekaardi saldot',
    gallery: 'Galerii',
  },

  invitation: {
    accept: 'Võta kutse vastu',
    decline: 'Keeldu kutsest',
    accepted: 'Kutse vastu võetud! Teie kontod on nüüd seotud.',
    declined: 'Kutse tagasi lükatud.',
    processing: 'Sinu vastuse töötlemine...',
    error: 'See kutse on kehtetu, aegunud või kontod on juba seotud.',
  },

  // Navigation
  nav: {
    title: 'Fire & Ice',
    home: 'Avaleht',
    bookSession: 'Broneeri aeg',
    myAccount: 'Minu konto',
    login: 'Logi sisse',
    logout: 'Logi välja',
    signUp: 'Registreeru',
    giftCards: 'Kinkekaardid',
    sessionBundles: 'Korrakaardid ja tellimused',
    services: 'Teenused',
    packages: 'Paketid',
    scienceStudies: 'Teadus',
    sessionBundlesShort: 'Korrakaardid',
    pricing: 'Hinnad',
    memberships: 'Liikmelisused',
    promotions: 'Kampaaniad',
    about: 'Kontakt',
    gallery: 'Galerii',
  },

  promotions: 'Kampaaniad',

  about: {
    title: 'Kontakt',
    description:
      "Tere tulemast Fire & Ice'i. Oleme pühendunud sinu tervise ja eluenergia optimeerimisele kontrastravi ja taastumisele suunatud teenuste kaudu.",
    contactInfo: 'Kontaktandmed',
    addressLabel: 'Aadress',
    emailLabel: 'E-post',
    phoneLabel: 'Telefon',
    howToFindUs: 'Kuidas meid leida',
    directions: 'Asume aadressil Hobujaama 4. Otsige sissepääsu põhikäiguraja kõrvalt.',
  },

  // Hero Section
  hero: {
    title: 'Elujõudu Eluks',
    subtitle: 'Fire and Ice — heaolustuudio mis aitab Sul:',
    benefit1: 'Vabaneda pingetest',
    benefit2: 'Taastuda kiiremini',
    benefit3: 'Uueneda seestpoolt',
    benefit4: 'Tõsta energiataset',
    benefit5: 'Parandada meeleolu',
  },

  services: 'Teenused',
  learnMore: 'Loe edasi',
  ourServices: 'Meie Wellness-teenused kehale ja meelele',
  ourPackages: 'Tutvu meie pakettidega',
  packageIncludes: 'Pakett sisaldab:',
  bookPackage: 'Broneeri pakett',
  min: 'min',

  // Auth
  auth: {
    logout: 'Logi välja',
    accountDeactivated: 'Konto deaktiveeritud',
    accountDeactivatedMessage:
      'Sinu konto on deaktiveeritud. Palun võta abi saamiseks ühendust klienditoega.',
  },

  // Session Bundles Page
  sessionBundles: {
    title: 'Meie korrakaardid ja liikmelisused',
    subtitle: 'Vali oma heaoluteekonnale sobiv korrakaart',
    loadingSessionBundles: 'Korrakaardide laadimine...',
    loadError: 'Pakettide laadimine ebaõnnestus. Palun proovi hiljem uuesti.',
    purchase: 'Osta',
    subscribe: 'Telli',
    per: '', // Estonian uses different word order, handled in component
    monthlySubscriptions: 'Igakuised tellimused',
    monthlySubscriptionsSpouse: 'Igakuised tellimused abikaasa allahindlusega',
    bulkSessionBundles: 'Korrakaardid (ühekordne ost)',
    bulkSessionBundlesSpouse: 'Korrakaardid abikaasa allahindlusega',
    showSpousePricing: 'Näita abikaasa hindu',
    spouseDisclaimer:
      '* Abikaasa hinnad on saadaval lingitud kontodele. Õigust kontrollitakse sisselogimisel.',
    sessionBundleTypeMonthly: 'Igakuine',
    spouseOffer: 'Abikaasa pakkumine',
    discountOff: '{{percentage}}% allahindlus',
    discountOffForMonths: '{{percentage}}% allahindlus {{months}} kuuks',
    perSession: 'seansi kohta',
  },

  // Pricing Page
  pricing: {
    title: 'Hinnad',
    subtitle: 'Tee esimene samm oma tervise heaks – vali sobiv pakett.',
    membership: 'Kuupakett',
    sessionBundle: 'Korrakaart',
    package: 'Pakett',
    packages: 'Paketti',
    packs: 'Pakki',
    visitsPerMonth: 'Kordi kuus',
    sessions: 'Seansid',
    regularPrice: 'Tavahind',
    price: 'Hind',
    openingDeal: 'Avamissoodustus 24 kuu tellimuselt (−{{percentage}}%)',
    openingDealSessionBundle: 'Avamishind (−{{percentage}}%)',
    pricePerSession: 'Parim hind liitumisel',
    notes: 'Märkused',
  },

  // Booking Page
  booking: {
    title: 'Broneeri aeg',
    titlePackage: 'Broneeri Pakett',
    selectService: 'Vali teenus',
    selectDateTime: 'Vali kuupäev ja aeg',
    loadingServices: 'Teenuste laadimine...',
    loadError: 'Teenuste laadimine ebaõnnestus. Palun proovi hiljem uuesti.',
    duration: 'Kestus',
    minutes: 'minutit',
    noAvailableSlots: 'Vabad ajad puuduvad',
    selectTime: 'Kellaaeg',
    confirmBooking: 'Kinnita broneering',
    bookingDetails: 'Broneeringu andmed',
    service: 'Teenus',
    date: 'Kuupäev',
    time: 'Aeg',
    confirmButton: 'Kinnita broneering',
    processing: 'Töötlemine...',
    success: 'Broneering kinnitatud!',
    error: 'Broneeringu kinnitamine ebaõnnestus. Palun proovi uuesti.',
    step1: '1. Vali teenus',
    step1package: '1. Vali pakett',
    step2: '2. Vali sobiv kuupäev ja kellaaeg',
    step3: '3. Kinnita broneering',
    selectDate: 'Kuupäev',
    loadingAvailableTimes: 'Vabad ajad laadimine...',
    noAvailableTimesForDate: 'Sellel kuupäeval vabad ajad puuduvad',
    confirmYourBooking: 'Kinnita oma broneering',
    confirmYourDetails: '3. Kinnita oma andmed',
    serviceLabel: 'Teenus:',
    dateLabel: 'Kuupäev:',
    timeLabel: 'Aeg:',
    durationLabel: 'Kestus:',
    totalLabel: 'Kokku:',
    contactInformation: 'Kontaktandmed',
    phoneNumberRequired: 'Telefoni number on vajalik broneeringu kinnitamiseks',
    phoneNumberInvalid: 'Palun sisesta korrektne telefoninumber',
    phoneNumberTooShortEst: 'Eesti telefoninumbrid peavad olema vähemalt 7-kohalised',
    phoneNumberTooLongEst: 'Eesti telefoninumbrid võivad olla maksimaalselt 8-kohalised',
    phoneNumberTooShort: 'Telefoninumber on liiga lühike',
    phoneNumberTooLong: 'Telefoninumber on liiga pikk',
    confirming: 'Kinnitan...',
    bookingFailed: 'Broneeringu loomine ebaõnnestus. Palun proovi uuesti.',
    step2ChooseDateTime: '2. Vali sobiv kuupäev ja aeg',
    bookAllSessions:
      'Palun vali broneerimisel kõik paketis sisalduvad teraapiad. Külastused võivad toimuda erineval ajal.',
    rescheduleTitle: 'Muuda broneeringut',
    rescheduleSubtitle: 'Vali broneeringule uus kuupäev ja aeg',
    currentBooking: 'Praegune broneering',
    confirmReschedule: 'Kinnita muudatus',
    reschedulingSuccess: 'Sinu broneering on edukalt muudetud!',
    reschedulingError: 'Broneeringu muutmine ebaõnnestus. Palun proovi uuesti.',
    participantsLabel: 'Külastajate arv:',
    enterGiftCardCode: 'Palun sisesta kinkekaardi kood',
    invalidGiftCardCode: 'Kehtetu kinkekaardi kood',
    giftCardError: 'Viga kinkekaardi rakendamisel',
    giftCardRedemptionFailed: 'Kinkekaardi lunastamine ebaõnnestus. Palun proovi uuesti.',
    giftCard: 'Kinkekaart',
    applying: 'Rakendan...',
    apply: 'Rakenda',
    fullyCoveredByGiftCard: 'Teie broneering on täielikult kaetud kinkekaardiga!',
    noPaymentRequired: 'Täiendavat makset pole vaja.',
    balance: 'Saldo',
    remainingBalance: 'Jääksaldo',
    remove: 'Eemalda',
    priceLabel: 'Hind:',
    confirmAndPay: 'Kinnita ja maksa',
    nameRequired: 'Nimi on kohustuslik',
    emailRequired: 'E-post on kohustuslik',
    emailInvalid: 'Vigane e-posti formaat',
    enterYourName: 'Sisesta oma nimi',
    enterYourEmail: 'Sisesta oma e-post',
    guestBookingSuccess: 'Broneering kinnitatud! Saate kinnituse e-postile.',
    bulkBookingSuccess: 'Edukalt loodud {{count}} broneeringut!',
    bulkBookingSuccessTitle: 'Broneeringud edukalt kinnitatud!',
    bookAnotherSession: 'Broneeri veel',
    chooseHowToProceed: 'Vali, kuidas soovid broneeringut jätkata',
    continueAsGuest: 'Jätka külalisena',
    loginToBook: 'Logi sisse või loo konto',
    paymentOption: 'Makseviis',
    isMixedCart: 'Segatud ostukorvide eest saab maksta ainult kaardiga või kohapeal.',
    remainingSessions: 'Jäänud seansid',
    subscriptions: 'Tellimused',
    sessionBundles: 'Korrakaardid',
    payByCard: 'Maksa kaardiga',
    payAtSite: 'Maksa kohapeal',
    paymentMethods: 'Maksemeetodid',
    infoSavedNote: 'Sinu andmed on salvestatud tulevaste broneeringute jaoks',
    unavailableTitle: 'Mittesaadaolevad tellimused ja paketid',
    unavailableMessage: 'Need tellimused ja paketid on aegunud või täielikult kasutatud.',
    sessionsRemaining: 'Jäänud seansid',
    status: 'Staatus',
    expired: 'Aegunud',
    insufficientCredits:
      'Sul on saadaval {{available}} seanssi, kuid proovid broneerida {{required}} seanssi.',
    insufficientCreditsActionStart: 'Palun ',
    insufficientCreditsActionModify: 'muutke oma broneeringut',
    insufficientCreditsActionMiddle: ' või ',
    insufficientCreditsActionPurchase: 'ostke lisapakett',
    insufficientCreditsActionEnd: '.',
  },

  // Account Page
  account: {
    title: 'Minu konto',
    personalInfo: 'Isikuandmed',
    email: 'E-post',
    name: 'Nimi',
    phoneNumber: 'Telefoninumber',
    gender: 'Sugu',
    birthday: 'Sünnipäev',
    upcomingBookings: 'Tulevased broneeringud',
    pastBookings: 'Varasemad broneeringud',
    cancelledBookings: 'Tühistatud broneeringud',
    noBookings: 'Broneeringuid ei leitud',
    cancelBooking: 'Tühista',
    cancelBookingConfirmTitle: 'Kas tühistada see broneering?',
    cancelBookingConfirmMessage:
      'Kas oled kindel, et soovid oma broneeringu teenusele {{serviceName}} tühistada kuupäeval {{date}} kell {{time}}?',
    cancelBookingYes: 'Jah, tühista broneering',
    cancelBookingNo: 'Säilita broneering',
    confirm: 'Kinnita',
    rescheduleBooking: 'Muuda aega',
    profile: 'Profiil',
    mySessionBundle: 'Minu korrakaart',
    mySessionBundlesAndSubscriptions: 'Minu korrakaardid, tellimused ja paketid',
    bookings: 'Broneeringud',
    notProvided: 'Pole sisestatud',
    edit: 'Muuda',
    save: 'Salvesta',
    cancel: 'Tühista',
    sessionsLeft: 'Seansse jäänud',
    expires: 'Aegub',
    activeSessionBundles: 'Aktiivsed korrakaardid',
    viewAllBookings: 'Vaata kõiki broneeringuid',
    spouseDiscount: 'Abikaasa allahindlus',
    spouseDiscountDesc: 'Sisesta oma abikaasa e-post, et anda talle juurdepääs sooduspakettidele.',
    sendInvite: 'Saada kutse',
    spouse: {
      title: 'Abikaasa konto',
      linked: 'Sinu konto on lingitud: {{email}}',
      pending: 'Kutse on ootel: {{email}}',
      declined:
        'Sinu eelmine kutse aadressile {{email}} lükati tagasi. Võid sisestada uue e-posti või sama e-posti, et proovida uuesti.',
      invite: 'Sisesta oma abikaasa e-post, et saata lingikutse.',
    },
    manageSubscription: 'Halda tellimust',
    sessionsRemaining: 'Seansse jäänud',
    sessionsUsed: 'Kasutatud/broneeritud seansse',
    renewalDate: 'Uuendamise kuupäev',
    activeSubscription: 'Aktiivne tellimus',
    renewsOn: 'Uueneb',
    loadingBookings: 'Broneeringute laadimine...',
    noBookingsYet: 'Broneeringuid pole veel. Broneeri oma esimene seanss!',
    minutes: 'minutit',
    phoneNumberUpdated: 'Telefoninumber edukalt uuendatud!',
    preferencesUpdated: 'Eelistused edukalt uuendatud!',
    promoOptIn: 'Soovin saada reklaamimeilid ja uudiskirju.',
    invitationSent: 'Kutse edukalt saadetud!',
    welcomeMessage:
      "Aitäh, et liitusid Fire & Ice'iga! Meil on hea meel sind oma heaolukogukonda tervitada. Võta hetk aega, et tutvuda oma kontoga ja avastada kõiki hämmastavaid teenuseid, mida pakume.",
    // Booking cancellation
    bookingCancelledSuccess: 'Broneering edukalt tühistatud!',
    bookingCancelFailed: 'Broneeringu tühistamine ebaõnnestus. Palun proovi uuesti.',
    cancellationPolicy24Hours:
      'Broneeringuid ei saa tühistada 24 tunni jooksul enne seansi algust.',
    reschedulingPolicy24Hours: 'Broneeringuid ei saa muuta 24 tunni jooksul enne seansi algust.',
    cannotCancel24Hours: 'Ei saa tühistada',
    cannotReschedule24Hours: 'Ei saa muuta',
    cancellationPolicyNotice:
      'Märkus: Broneeringut saab tühistada kuni 24 tundi enne seansi algust.',
    // Phone number validation errors
    phoneNumberTooShortEst: 'Eesti telefoninumbrid peavad olema vähemalt 7-kohalised',
    phoneNumberTooLongEst: 'Eesti telefoninumbrid võivad olla maksimaalselt 8-kohalised',
    phoneNumberTooShort: 'Telefoninumber on liiga lühike',
    phoneNumberTooLong: 'Telefoninumber on liiga pikk',
    phoneNumberInvalid: 'Palun sisesta kehtiv telefoninumber',
    unusedSessionsNote: 'Sinu kasutamata seansid kantakse edasi kuni 3 kuuks.',
    confirmed: 'kinnitatud',
    cancelled: 'tühistatud',
    at: 'kell',
    sessionsRolledOver: 'Üle kantud',
    expiresOn: 'Aegub',
    bookAgain: 'Broneeri uuesti',
    filterAll: 'Kõik',
    filterUpcoming: 'Tulevased',
    filterPast: 'Varasemad',
    filterCancelled: 'Tühistatud',
    searchBookings: 'Otsi broneeringuid...',
    noUpcomingBookings: 'Tulevasi broneeringuid ei ole',
    readyToBook: 'Kas oled valmis oma järgmist heaoluseansi broneerima?',
    noPastBookings: 'Varasemaid broneeringuid ei ole',
    bookingHistoryWillAppear: 'Sinu broneeringute ajalugu ilmub siia',
    noCancelledBookings: 'Tühistatud broneeringuid ei ole',
    cancelledBookingsWillAppear: 'Tühistatud broneeringud ilmuvad siia',
    bookYourFirstSession: 'Broneeri oma esimene seanss',
    participants: 'osalejat',
    loadingSessionBundles: 'Korrakaardide laadimine...',
    noActiveSessionBundles: 'Aktiivseid korrakaarte ei ole',
    myPackagePacks: 'Minu paketi pakid',
    noActivePackagePacks: 'Aktiivseid paketi pakke ei ole',
    packsRemaining: 'Pakke jäänud',
    packsUsed: 'Kasutatud pakke',
    usedPackagePacksTitle: 'Kasutatud paketi pakid',
    // Subscription management
    mySubscription: 'Minu tellimus',
    subscription: 'Tellimus',
    cancelSubscription: 'Tühista tellimus',
    cancelConfirmTitle: 'Tühista tellimus?',
    cancelConfirmMessage:
      'Kas oled kindel, et soovid tühistada? Sinu eelised jätkuvad kuni {{endDate}}.',
    cancelSuccess: 'Sinu tellimus on tühistatud ja lõpeb {{endDate}}.',
    cancelError: 'Tellimuse tühistamine ebaõnnestus. Palun võta ühendust klienditoega.',
    subscriptionExpires: 'Sinu tellimus on aktiivne ja lõpeb {{endDate}}.',
    subscriptionRenews: 'Sinu tellimus uueneb {{endDate}}.',
    keep: 'Jätka tellimust',
    noActiveSubscription: 'Aktiivseid tellimusi ei ole',
    nameRequired: 'Nimi on kohustuslik',
    nameUpdated: 'Nimi edukalt uuendatud',
    emailInvalid: 'Palun sisesta kehtiv e-posti aadress',
    emailUpdateInitiated:
      'Nõutav on kinnitus. Palun kontrolli oma uut e-posti aadressi kinnituslingi saamiseks.',
    emailChangeSubmitted:
      'Saatsime kinnituslingi sinu uuele e-posti aadressile. Palun klõpsa selles e-kirjas olevat linki, et muudatus lõpule viia.',
    expiredSectionTitle: 'Aegunud tellimused ja kasutatud paketid',
    subscriptionExpiredOn: 'Aegunud',
    sessionBundleFullyUsed: 'Korrakaart täielikult kasutatud',
    notificationPreferences: 'Teavituste eelistused',
    receiveEmailReminders: 'Saada broneeringu meeldetuletused e-posti teel',
    receiveSmsReminders: 'Saada broneeringu meeldetuletused SMS-i teel',
    noPhoneNumber: 'Telefoninumber puudub',
    addPhoneToEnable: 'Lisa telefon lubamiseks',
    session: 'Seanss',
  },

  // Email Verification
  verifyEmail: {
    title: 'E-posti kinnitamine',
    verifying: 'Sinu e-posti kinnitamine...',
    success: 'Sinu e-posti aadress on edukalt uuendatud!',
    errorTitle: 'Kinnitamine ebaõnnestus',
    noToken: 'Kinnitustokenit ei leitud.',
    genericError: 'Ilmnes viga.',
    backToAccount: 'Mine minu kontole',
    redirecting: 'Sind suunatakse 3 sekundi pärast sinu profiilile...',
    clickHereToReturn: 'Kui sind ei suunata ümber, klõpsa siin, et naasta oma profiilile.',
  },

  // Email Templates
  email: {
    verification: {
      subject: 'Kinnita oma uus e-posti aadress - Fire & Ice',
      heading: 'Kinnita oma uus e-posti aadress',
      body: 'Hiljuti taotlesid oma Fire & Ice kontoga seotud e-posti aadressi muutmist. Selle muudatuse kinnitamiseks klõpsa allolevat nuppu. Link kehtib 1 tund.',
      button: 'Kinnita oma uus e-posti aadress',
      disclaimer:
        'Kui sa ei taotlenud seda e-posti aadressi muutmist, võid selle e-kirja turvaliselt ignoreerida.',
    },
    bookingConfirmation: {
      subject: 'Sinu Fire & Ice broneeringu kinnitus',
      heading: 'Broneering kinnitatud!',
      greeting: 'Tere',
      bodyIntro:
        'Täname broneeringu eest. Siin on üksikasjalik teave sinu tulevase(te) seansi(de) kohta:',
      bookingListHeader: 'Sinu broneeringud',
      payAtSiteLabel: 'Kohapeal makstav summa',
    },
    bookingReminder: {
      subject: 'Meeldetuletus: Sinu Fire & Ice broneering homme',
      heading: '⏰ Broneeringu meeldetuletus',
      greeting: 'Tere',
      bodyIntro: 'See on sõbralik meeldetuletus, et sul on homme broneering.',
      closingMessage: 'Ootame sind!',
      footerMessage: 'See on automaatne meeldetuletus sinu tulevase broneeringu kohta.',
    },
    dailyReminder: {
      subject: 'Meeldetuletus: Sinu Fire & Ice broneeringud täna',
      heading: 'Fire & Ice broneeringu meeldetuletus',
      greeting: 'Tere',
      greetingSingle: 'Sul on täna kohtumine:',
      greetingMultiple: 'Sul on täna {{count}} kohtumist:',
      closingMessage: 'Ootame sind!',
      footerMessage: 'See on automaatne meeldetuletus sinu tulevase(te) broneeringu(te) kohta.',
    },
    purchaseConfirmation: {
      subject: 'Sinu Fire & Ice ostu kinnitus',
      heading: 'Ost kinnitatud!',
      bodyIntroSessionBundle:
        'Täname ostu eest! Sinu uus korrakaart on aktiivne ja kasutamiseks valmis.',
      bodyIntroSubscription:
        'Täname ostu eest! Sinu uus tellimus on aktiivne ja kasutamiseks valmis.',
      detailsLabel: 'Ostu üksikasjad:',
      priceLabel: 'Makstud summa:',
      sessionBundleInfo:
        'Oled ostnud {{sessions}} seanssi. Seansside kasutamiseks ei ole ajapiirangut - need ei aegu kunagi!',
      subscriptionInfo:
        'Sinu tellimus uueneb automaatselt {{renewalDate}}. Kasutamata seansid kantakse edasi kuni 3 kuuks. Saad oma tellimuse igal ajal tühistada oma konto jaotises Fire & Ice veebilehel.',
      ctaHeading: 'Valmis alustama?',
      ctaBody:
        "Tutvuge meie terviseteenuste valikuga ja broneeri oma esimene seanss juba täna. Ootame teid Fire & Ice'i!",
      ctaButton: 'Broneeri oma esimene seanss',
    },
    rescheduleConfirmation: {
      subject: 'Sinu Fire & Ice broneering on ümber planeeritud',
      heading: 'Broneering ümber planeeritud',
      bodyIntro: 'Sinu broneering järgmise teenuse jaoks on edukalt ümber planeeritud:',
      serviceLabel: 'Teenus:',
      oldBookingHeading: 'Eelmine aeg',
      newBookingHeading: 'Uus aeg',
      dateLabel: 'Kuupäev:',
      timeLabel: 'Kellaaeg:',
    },
    cancellationConfirmation: {
      subject: 'Sinu Fire & Ice broneering on tühistatud',
      heading: 'Broneering tühistatud',
      bodyIntro: 'Sinu broneering järgmise teenuse jaoks on edukalt tühistatud:',
      bookingDetails: 'Tühistatud broneeringu üksikasjad:',
      serviceLabel: 'Teenus:',
      dateLabel: 'Kuupäev:',
      timeLabel: 'Kellaaeg:',
      refundNoticeSessionBundle: 'Seansikrediit on sinu aktiivsele korrakaardile tagastatud.',
      refundNoticeSubscription: 'Seansikrediit on sinu aktiivsele tellimisele tagastatud.',
      refundNoticePaid: 'Sinu broneering tasuti kaardiga ja see ei ole tagastatav.',
      refundNoticeDefault: 'Sinu broneering on tühistatud.',
    },
    spouseInvite: {
      subject: 'Abikaasa konto kutse - Fire & Ice',
      heading: 'Teid kutsutakse!',
      body: 'kutsus teid oma Fire & Ice konto abikaasaks siduma.',
      acceptButton: 'Nõustu kutsega',
      declineButton: 'Keeldu',
    },
    spouseResponse: {
      subject: 'Abikaasa konto vastus - Fire & Ice',
      heading: 'Kutse vastus',
      bodyAccepted: 'nõustus sinu abikaasa konto kutsega!',
      bodyDeclined: 'keeldus sinu abikaasa konto kutsest.',
    },
    footer: {
      company: 'Fire and Ice',
      address: 'Hobujaama tn 4, Tallinn',
      emailSentTo: 'See e-kiri saadeti aadressile',
      reason: "Said selle e-kirja, sest registreerusid Fire & Ice'i kontole.",
    },
  },

  // Complete Registration
  registration: {
    title: 'Lõpeta registreerimine',
    subtitle: 'Palun sisesta järgmine teave oma konto seadistamiseks',
    firstName: 'Eesnimi',
    lastName: 'Perekonnanimi',
    phoneNumber: 'Telefoninumber',
    phoneNumberPlaceholder: 'nt +372 5123 4567',
    submit: 'Lõpeta registreerimine',
    submitting: 'Saadan...',
    success: 'Registreerimine õnnestus!',
    error: 'Registreerimine ebaõnnestus. Palun proovi uuesti.',
    oneLastStep: 'Veel üks samm...',
    welcome: "Tere tulemast Fire & Ice'i",
    reviewTerms:
      'Palun vaata üle ja nõustu järgmiste tingimustega registreerimise lõpuleviimiseks.',
    agreeToTerms: 'Nõustun',
    termsOfService: 'Kasutustingimustega',
    promoOptIn: 'Soovin saada reklaamimeilid ja uudiskirju.',
    agreeToEmails: 'Nõustun turundusmeile saama',
    completeSignUp: 'Lõpeta registreerumine',
    completing: 'Lõpetan...',
    mustAgreeToTerms: 'Jätkamiseks pead nõustuma kasutustingimustega.',
    errorOccurred: 'Tekkis viga. Palun proovi uuesti.',
    nameLabel: 'Täisnimi',
    namePlaceholder: 'Sisesta oma täisnimi',
    nameRequired: 'Palun sisesta oma nimi.',
    gender: 'Sugu',
    genderPlaceholder: 'Vali oma sugu',
    male: 'Mees',
    female: 'Naine',
    birthday: 'Sünnipäev',
    birthdayPlaceholder: 'Vali oma sünnipäev',
    birthdayInFuture: 'Sünnipäev ei saa olla tulevikus',
  },

  // Error messages
  errors: {
    unauthorized: 'Sellele lehele juurdepääsuks pead sisse logima',
    notFound: 'Lehte ei leitud',
    general: 'Midagi läks valesti. Palun proovi uuesti.',
    // Auth callback errors
    authenticationError: 'Autentimise viga',
    authenticationErrorMessage: 'Autentimisel tekkis viga. Teid suunatakse avalehele.',
    authError: 'Viga: {{message}}',
    redirecting: 'Ümbersuunamine...',
    authenticating: 'Autentimine...',
    loading: 'Laadimine...',
    missingCallbackParams: 'Puuduvad nõutud tagasihelistamise parameetrid',
    // Auth0 configuration errors
    auth0ConfigMissing:
      'Auth0 konfiguratsioon puudub. Palun kontrolli REACT_APP_AUTH0_DOMAIN ja REACT_APP_AUTH0_CLIENT_ID keskkonnamuutujaid.',
    auth0ConfigError:
      'Auth0 konfiguratsiooni viga. Palun kontrolli konsooli üksikasjade saamiseks.',
    confirmationFailed: 'Kinnitus ebaõnnestus. ',
    paymentNotSucceeded: 'Makse ei õnnestunud.',

    // API Error Codes
    api: {
      AUTH_TOKEN_MISSING: 'Autentimine on nõutud. Palun logi sisse.',
      AUTH_TOKEN_INVALID: 'Sinu seanss on aegunud. Palun logi uuesti sisse.',
      AUTH_UNAUTHORIZED: 'Sul pole selle tegevuse teostamiseks õigusi.',

      BOOKING_NOT_FOUND: 'Broneeringut ei leitud.',
      BOOKING_CANNOT_CANCEL: 'Ei saa tühistada broneeringut 24 tunni jooksul enne vastuvõtuaega.',
      BOOKING_ALREADY_CANCELLED: 'See broneering on juba tühistatud.',
      BOOKING_SLOT_UNAVAILABLE: 'See ajavahemik ei ole enam saadaval.',
      BOOKING_INVALID_DATA: 'Esitati vale broneeringu teave.',
      BOOKING_REQUIRED_FIELDS_MISSING: 'Nõutav broneeringu teave puudub.',
      BOOKING_BULK_PARTIAL_FAILURE: 'Mõned broneeringud ei õnnestunud.',
      BOOKING_BULK_COMPLETE_FAILURE: 'Broneeringute lõpuleviimine ei õnnestunud.',

      PAYMENT_REQUIRED: 'Selle broneeringu lõpuleviimiseks on vaja makset.',
      PAYMENT_FAILED: 'Makse ebaõnnestus. Palun proovi uuesti.',
      PAYMENT_INVALID_AMOUNT: 'Vale maksesumma.',
      PAYMENT_CARD_DECLINED: 'Sinu kaart lükati tagasi. Palun proovi muud makseviisi.',

      GIFT_CARD_NOT_FOUND: 'Kinkekaart ei leitud või on kehtetu.',
      GIFT_CARD_INSUFFICIENT_BALANCE: 'Kinkekaardi saldo ei ole piisav.',
      GIFT_CARD_INVALID_AMOUNT: 'Vale kinkekaardi summa.',

      PROMO_CODE_NOT_FOUND: 'Sooduskoodi ei leitud või see on kehtetu.',

      SESSION_BUNDLE_NOT_FOUND: 'Paketti või tellimust ei leitud.',
      SESSION_BUNDLE_NO_USES_REMAINING: 'Sellel paketil ei ole ülejäänud kasutuskorde.',
      SESSION_BUNDLE_ALREADY_PURCHASED: 'Sul on see pakett juba olemas.',

      USER_NOT_FOUND: 'Kasutajat ei leitud.',
      CLIENT_NOT_FOUND: 'Klienti ei leitud.',

      SERVICE_NOT_FOUND: 'Teenust ei leitud.',
      SERVICE_UNAVAILABLE: 'See teenus ei ole praegu saadaval.',

      INVALID_REQUEST: 'Kehtetu päring.',
      VALIDATION_ERROR: 'Palun kontrolli oma sisestust ja proovi uuesti.',

      INTERNAL_ERROR: 'Tekkis viga. Palun proovi uuesti.',
      EXTERNAL_API_ERROR: 'Teenus on ajutiselt kättesaamatu. Palun proovi hiljem uuesti.',
    },
  },

  // Date/Time formatting
  dateTime: {
    today: 'Täna',
    tomorrow: 'Homme',
    weekdays: ['Pühapäev', 'Esmaspäev', 'Teisipäev', 'Kolmapäev', 'Neljapäev', 'Reede', 'Laupäev'],
    months: [
      'Jaanuar',
      'Veebruar',
      'Märts',
      'Aprill',
      'Mai',
      'Juuni',
      'Juuli',
      'August',
      'September',
      'Oktoober',
      'November',
      'Detsember',
    ],
  },

  // Footer
  footer: {
    services: 'TEENUSED',
    infraredSauna: 'Infrapunasaun',
    coldPlunge: 'Külm suplus',
    cryotherapy: 'Krüoteraapia',
    redLightTherapy: 'Punase valguse teraapia',
    cellumaFacialLightTherapy: 'Celluma näo valgusteraapia',
    compressionMassage: 'Kompressioonteraapia',
    gallery: 'GALERII',
    scienceAndStudies: 'TEADUS JA UURINGUD',
    specialOffers: 'ERIPAKKUMISED',
    pricing: 'HINNAD',
    bookNow: 'BRONEERI KOHE',
    copyright: '© {year} Fire and Ice. Kõik õigused kaitstud.',
    checkGiftCardBalance: 'Kontrolli kinkekaardi saldot',
    privacyNotice: 'Privaatsuspoliitika',
    termsOfService: 'Kasutustingimused',
  },

  // Promotion
  promo: {
    code: 'Sooduskood',
    have: 'Kas sul on sooduskood?',
    applied: 'Sooduskood rakendatud',
    placeholder: 'Sisesta sooduskood',
    errors: {
      missingCode: 'Palun sisesta sooduskood.',
      validationError: 'Sooduskoodi valideerimisel ilmnes viga.',
      invalidCode: 'Kehtetu sooduskood',
    },
  },

  // Gift Card
  giftCard: {
    have: 'Kas sul on kinkekaart?',
    applied: 'Kinkekaart rakendatud',
    purchaseTitle: 'Osta Fire & Ice e-kinkekaart',
    purchaseDescription:
      'Kinkekaart kehtib üks aasta ning seda saab kasutada kõigi teenuste ja pakettide eest tasumiseks.',
    chooseAmount: 'Vali kinkekaardi väärtus',
    other: 'Muu',
    enterAmountPlaceholder: 'Sisesta summa - miinimum 50 €',
    to: 'Kinkekaardi saaja andmed',
    recipientName: 'Saaja nimi',
    recipientNamePlaceholder: 'Mart Maasikas',
    deliveryEmail: 'Saaja e-posti aadress',
    recipientEmailPlaceholder: 'mart@näide.ee',
    from: 'Tellija andmed:',
    yourName: 'Nimi',
    yourNamePlaceholder: 'Sinu nimi',
    yourEmail: 'E-post',
    yourEmailPlaceholder: 'sinu@näide.ee',
    yourPhone: 'Telefon',
    yourPhonePlaceholder: '+372 5123 4567',
    personalMessage: 'Lisa personaalne tervitus (valikuline)',
    personalMessagePlaceholder: 'Kirjutage oma sõnum siia...',
    characters: 'tähemärki',
    processing: 'Töötlemine...',
    proceedToPayment: 'Jätka maksega',
    completePayment: 'Lõpeta makse',
    minimumAmountError: 'Kinkekaardi miinimumsumma on 50 €',
    successMessage: 'Kinkekaart edukalt loodud! Kood: {{code}}',
    errorMessage: 'Kinkekaardi loomine ebaõnnestus. Palun kontrolli oma andmeid ja proovi uuesti.',
    session: '{{count}} seanss',
    sessions: '{{count}} seanssi',
    // Gift Card Balance Page
    balancePageTitle: 'Kontrolli oma kinkekaardi saldot',
    balancePageSubtitle: 'Sisesta oma kinkekaardi kood, et näha järelejäänud saldot.',
    codePlaceholder: 'XXXX-XXXX-XXXX',
    checkingBalance: 'Kontrollin...',
    checkBalance: 'Kontrolli saldot',
    currentBalance: 'Hetke saldo:',
    invalidCode: 'Vigane kinkekaardi kood.',
    checkError: 'Tekkis viga. Palun proovi uuesti.',
    enterCode: 'Palun sisesta kinkekaardi kood.',
    cardDepleted: 'See kinkekaart on täielikult kasutatud ja pole enam kehtiv.',
    successPageTitle: 'Kinkekaardi ost õnnestus!',
    successPageMessage: 'Sinu kinkekaart on ostetud ja saadetud saajale.',
    detailsTitle: 'Ostu üksikasjad',
    giftCardCode: 'Kinkekaardi kood',
    codeInfo: 'Saaja saab selle koodi e-posti teel.',
    amount: 'Summa',
    emailConfirmation: 'Kinnituskiri on saadetud aadressile {{email}}.',
    emailSubject: 'Oled saanud kinkekaardi kasutajalt {{senderName}}!',
    emailHeading: 'Oled saanud kinkekaardi!',
    emailIntro: 'saatis sulle kinkekaardi!',
    amountLabel: 'Kinkekaardi väärtus',
    codeLabel: 'Sinu kinkekaardi kood',
    messageLabel: 'Isiklik sõnum',
    emailInstructions:
      'Kasuta seda koodi oma järgmise Fire & Ice seansi broneerimisel või pakettide ja tellimuste ostmisel.',
    ctaText: 'Broneeri kohe',
  },

  // Booking Upsell
  upsell: {
    message: 'Broneerid üksikuid seansse? Korrakaart või püsitellimus tuleb soodsam.',
    linkText: 'Vaata erinevaid võimalusi',
  },

  // Service Page
  servicePage: {
    bookNow: 'Broneeri kohe',
    faqHeading: 'Korduma kippuvad küsimused',
  },

  // Booking Cart
  cart: {
    title: 'Sinu broneeringu valik',
    empty: 'Sinu valik on tühi.',
    addToCart: 'Broneeri aeg',
    bookNow: 'Broneeri kohe',
    addedToCart: 'Lisatud sinu broneeringu valikule!',
    bookingChanged: 'Broneering on muudetud',
    change: 'Muuda',
    remove: 'Eemalda',
    confirmRemove: 'Kas oled kindel, et soovid selle broneeringu oma ostukorvist eemaldada?',
    total: 'Kokku',
    at: 'kell',
    addAnotherService: 'Lisa teenus',
    proceedToCheckout: 'Kinnita broneering',
    suggestedServices: 'Täienda oma külastust',
    suggestedServicesDescription:
      'Need teenused on saadaval kohe pärast Sinu viimast broneeringut:',
    available: 'Saadaval kell',
    bookingSelected: 'Valitud broneering',
    bookingsSelected: 'Valitud broneeringud',
    removeBookingTitle: 'Eemalda Broneering',
    confirmChange: 'Kinnita Muudatus',
    credits: 'Krediiti',
    participants: 'Külastajate arv:',
    participantEmails: 'Osalejate e-postid (valikuline):',
    participantEmailPlaceholder: 'Osaleja {{count}} e-post',
  },

  // Checkout Page
  checkout: {
    title: 'Broneeri aeg',
    bookingSummary: 'Broneeringute kokkuvõte',
    orderSummary: 'Tellimuse kokkuvõte',
    paymentDetails: 'Makseandmed',
    securePaymentInfo: "Sinu makse töödeldakse turvaliselt Stripe'i kaudu.",
    cardDetails: 'Kaardi andmed',
    cardNumber: 'Kaardi number',
    expiryDate: 'Kehtivusaeg',
    cvc: 'CVC',
    processing: 'Töötlemine...',
    completeOrder: 'Lõpeta tellimus',
    payAmount: 'Maksa {{amount}}',
    cardElementError: 'Kaardi element ei leitud',
    paymentError: 'Makse ebaõnnestus. Palun proovi uuesti.',
    sessionBundleNotFound: 'Korrakaarti ei leitud',
    packagePackNotFound: 'Paketi pakki ei leitud',
    loadError: 'Paketi andmete laadimine ebaõnnestus',
    enterGiftCardCode: 'Palun sisesta kinkekaardi kood',
    giftCardNoBalance: 'Sellel kinkekaardil pole saldot',
    invalidCode: 'Vigane kood',
    monthlySubscription: 'Igakuine tellimus',
    bulkSessionBundle: 'Korrakaart',
    sessions: 'seanssi',
    subtotal: 'Vahesumma',
    promotionDiscount: 'Kampaania allahindlus',
    promotionCodeDiscount: 'Sooduskoodi allahindlus',
    giftCardDiscount: 'Kinkekaardi allahindlus',
    total: 'Kokku',
    enterCode: 'Sisesta kood',
    apply: 'Rakenda',
    remove: 'Eemalda',
    customerInfo: 'Kliendi andmed',
    name: 'Nimi',
    email: 'E-post',
    unavailable: 'Pole saadaval',
    unavailableItemsMessage:
      'Mõned broneeringud pole enam saadaval. Palun eemalda need jätkamiseks.',
    removeUnavailable: 'Eemalda Mittesaadaolevad Broneeringud',
    bookingInfo:
      'Sinu broneeringud kinnitatakse kohe. Saad neid hiljem mugavalt hallata oma konto lehel.',
    confirmBookings: 'Kinnita broneeringud',
    processingOrder: 'Tellimuse töötlemine',
    pleaseWait: 'Palun oota, kuni kinnitame sinu ostu...',
  },

  // Purchase Confirmation Page
  confirmation: {
    title: 'Ostu kinnitus',
    successTitle: 'Täname teid ostu eest!',
    successMessage: 'Sinu tellimus on edukalt lõpetatud.',
    noData: 'Tellimuse andmed pole saadaval',
    orderDetails: 'Tellimuse üksikasjad',
    sessionBundle: 'Korrakaart',
    subscription: 'Tellimus',
    amountPaid: 'Makstud summa',
    paymentMethod: 'Makseviis',
    giftCardOnly: 'Kinkekaart',
    cardAndGiftCard: 'Krediitkaart ja kinkekaart',
    whatNext: 'Mis edasi?',
    confirmationEmail: 'Saate peagi kinnitusmeili oma ostu üksikasjadega.',
    bookSession: 'Broneeri aeg',
    goToAccount: 'Mine minu kontole',
    contractError: 'Sinu paketi aktiveerimisel tekkis probleem. Palun võta ühendust toega.',
    creatingContract: 'Viimistlen sinu ostu, palun oota...',
  },

  // Newsletter
  newsletter: {
    title: 'Liitu meie uudiskirjaga',
    subtitle: "Jagame sinuga aeg-ajalt kasulikke nippe ja uudiseid wellness'i maailmast.",
    firstNamePlaceholder: 'Eesnimi',
    lastNamePlaceholder: 'Perekonnanimi',
    emailPlaceholder: 'Sisesta oma e-post',
    subscribing: 'Liitun...',
    subscribe: 'Liitu',
    successMessage: 'Täname liitumise eest!',
    errorMessage: 'Midagi läks valesti. Palun proovi uuesti.',
  },

  // Console messages (for debugging)
  console: {
    errors: {
      fetchingBookings: 'Viga broneeringute laadimisel:',
      fetchingUserSessionBundles: 'Viga kasutaja pakettide laadimisel:',
      cancellingBooking: 'Viga broneeringu tühistamisel:',
      fetchingSessionBundles: 'Viga korrakaartide laadimisel:',
      fetchingServices: 'Viga teenuste laadimisel:',
      completingRegistration: 'Viga registreerimise lõpetamisel:',
      creatingBooking: 'Viga broneeringu loomisel:',
      fetchingService: 'Viga teenuse laadimisel:',
      fetchingAvailability: 'Viga saadavuse laadimisel:',
      reschedulingBooking: 'Viga broneeringu ümberplaanimisel:',
      fetchingGiftCardBalance: 'Viga kinkekaardi saldo laadimisel:',
      giftCardRedemptionFailed: 'Kinkekaardi lunastamine ebaõnnestus:',
      creatingGiftCard: 'Viga kinkekaardi loomisel:',
      authCallbackError: 'Auth0 tagasikutsumise viga:',
      authErrorDetails: 'Auth0 vea üksikasjad:',
    },
  },

  // Coupon Codes
  coupon: {
    title: 'Kupongikood',
    haveCoupon: 'Kas teil on kupongikood?',
    placeholder: 'Sisesta kupongikood',
    applied: 'Kupong rakendatud!',
    sessionsIncluded: '{{count}} seanssi sisaldub',
    sessionsAlreadyUsed: '{{count}} seanssi juba kasutatud',
    bookAnotherLater: 'Broneeri hiljem teine seanss, et kasutada oma tasuta seanssi!',
    youSave: 'Säästad',
    cancellationPolicyTitle: 'Seotud broneeringute poliitika',
    cancellationPolicyText:
      'Mõlemad seansid tuleb koos tühistada. Kui tühistate ühe seansi, tühistatakse mõlemad seansid ja kupong taastatakse edaspidiseks kasutamiseks.',
    // Coupon pair cancellation
    sessionBadge: 'Kupong',
    cancelPairTitle: 'Tühista kupongi seansid',
    linkedBookingNotice: 'Seotud kupongi broneering',
    pairCancellationExplanation:
      'See broneering kuulub kupongipaari. Täieliku tagasimakse saamiseks tuleb mõlemad seansid koos tühistada.',
    pairCancellationConfirm:
      'Tühistamine tühistab mõlemad kupongi seansid ja tagastab {{amount}}. Sinu kupongikood taastatakse edaspidiseks kasutamiseks.',
    linkedSessions: 'Tühistatavad seotud seansid:',
    cancelBothSessions: 'Tühista mõlemad seansid',
    pairCancellationSuccess:
      'Mõlemad kupongi seansid on edukalt tühistatud. {{amount}} tagastatud. Kupong taastatud taaskasutamiseks.',
    errors: {
      missingCode: 'Palun sisesta kupongikood.',
      missingEmail: 'Kupongi kontrollimiseks on vaja e-posti aadressi.',
      invalidCode: 'See kupongikood on kehtetu või aegunud.',
      alreadyUsed: 'See kupongikood on juba täielikult kasutatud.',
      noSessions: 'Palun lisa ostukorvi vähemalt üks seanss.',
      validationError: 'Kupongikoodi valideerimisel tekkis viga.',
      sessionAlreadyUsed:
        'Tühistamine pole võimalik: üks või mitu seotud seanssi on juba kasutatud. Sul võib siiski olla võimalik ümber broneerida 24 tunni jooksul enne kohtumist.',
      cannotCancel: 'Nende seansside tühistamine pole praegu võimalik.',
    },
    success: 'Kupong rakendatud! Säästad {{discount}}.',
  },

  // Gallery
  gallery: {
    title: 'Galerii',
    subtitle: 'Tutvu meie wellness-stuudio hetkedega',
    pageTitle: 'Galerii',
    pageDescription: 'Sirvi Fire & Ice wellness-kogemuste galeriid Tallinnas.',
    viewImage: 'Vaata pilti',
    lightboxLabel: 'Pildi vaataja',
    previousImage: 'Eelmine pilt',
    nextImage: 'Järgmine pilt',
    loadError: 'Galerii laadimine ebaõnnestus',
    noImages: 'Pilte ei ole saadaval',
  },

  // SEO
  seo: {
    defaultTitle: 'Fire & Ice - Heaolu ja Taastumine',
    defaultDescription:
      "Koge parimat heaolu teekonda Fire & Ice'iga. Premium kontrastteraapia teenused, sealhulgas saun, külmavann ja palju muud Tallinnas.",
    homeDescription:
      'Fire and Ice on koht, kus saad aja maha võtta ja lasta enda eest hoolitseda. Näo- ja kehahooldused, mis toetavad nii ilu kui ka tervist. Broneeri aeg juba täna.',
    privacyDescription:
      'Tutvu meie privaatsustingimustega ja saa selge ülevaade isikuandmete kogumisest, kasutamisest ja kaitsmisest. Loe lähemalt.',
    bookDescription:
      'Broneeri Fire and Ice wellness-hoolitsus endale sobival ajal. Vali teenus ja aeg ning tule naudi uue ajastu heaolukogemust. Ootame sind!',
    termsDescription:
      'Fire and Ice kasutustingimused selgitavad teenuste kasutamise korda, kasutaja õigusi ja vastutust. Soovitame tutvuda tingimustega enne broneerimist.',
    pricingDescription:
      'Vaata Fire and Ice hoolitsuste hinnakirja ja paketivalikuid. Leia endale sobiv lahendus ning broneeri seanss mugavalt.',
    promotionsDescription:
      'Tutvu Fire and Ice sooduspakkumiste ja erikampaaniatega. Kasuta võimalust proovida wellness-hoolitsusi soodsamalt ja broneeri aeg mugavalt.',
    contactDescription:
      'Leia Fire and Ice kontaktandmed ja asukoht. Kui sul on küsimusi teenuste või broneerimise kohta, võta meiega ühendust.',
    scienceStudiesDescription:
      'Meie teenused põhinevad teadusuuringutel ja tõenduspõhistel meetoditel. Uuri lähemalt, kuidas need aitavad sul taastuda ja end paremini tunda.',
    checkBalanceDescription:
      'Sisesta andmed ja saa kohe teada, kui palju on su Fire and Ice kinkekaardil alles. Lihtne, kiire ja mugav!',
    galleryDescription:
      "Sirvi meie wellness-kogemuste galeriid Fire & Ice'is. Vaata meie sauna, külmavanni ja taastumisvõimalusi Tallinnas.",
    services: {
      'infrared-sauna':
        'Infrapunasaun aitab lõõgastuda, toetab taastumist ja parandab enesetunnet. Naudi rahulikku keskkonda ja broneeri seanss mugavalt veebis.',
      'compression-massage':
        'Kompressioonmassaaž parandab vereringet ja toetab taastumist. Lõõgastu, taastu ning broneeri seanss mugavalt veebis.',
      'contrast-therapy':
        'Kontrastteraapia ühendab külma ja sooja mõju, aidates kehal taastuda ja parandades enesetunnet. Broneeri seanss mugavalt veebis.',
      'celluma-facial-light-therapy':
        'Celluma LED-valgusravi näole aitab parandada naha tekstuuri, vähendada põletikku ja toetada kollageeni tootmist. Broneeri seanss.',
      'cryotherapy-full-body':
        'Kogu keha krüoteraapia pakub intensiivset külmakogemust, mis toetab taastumist ja parandab enesetunnet. Broneeri seanss mugavalt veebis.',
      'cold-plunge':
        'Külmaveeprotseduur pakub värskendavat kogemust, mis toetab taastumist ja parandab enesetunnet. Koge külma mõju ja broneeri seanss mugavalt.',
      'red-light-therapy':
        'Punase valguse teraapia aitab kehal taastuda ja tõstab heaolutunnet. Võta aeg maha ja broneeri seanss lihtsalt veebis.',
    },
  },

  // Birthday Picker
  birthdayPicker: {
    selectYear: 'Vali aasta',
    selectMonth: 'Vali kuu',
    selectDay: 'Vali päev',
    placeholder: 'pp/kk/aaaa',
  },
};
